import { useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { any, equals } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getMessage } from '@gef-ui/localization/messages';

import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { startupTodaysUrgencies } from 'features/views/dashboard/todaysUrgencies/actions';
import {
	getCampaignsNearingTheEndContactRelease,
	getCampaignsNearingTheEndManager,
	getEscalationBasic,
	getEscalationSummary,
	getLeadsToProcess,
} from 'features/views/dashboard/todaysUrgencies/selectors';

import CampaignsNearingTheEndContactRelease from './components/CampaignsNearingTheEndContactRelease';
import CampaignsNearingTheEndManager from './components/CampaignsNearingTheEndManager';
import EscalationBasic from './components/EscalationBasic';
import EscalationSummary from './components/EscalationSummary';
import LeadsToProcess from './components/LeadsToProcess';

export const TodaysUrgencies = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(startupTodaysUrgencies());
	}, [dispatch]);

	const escalationBasic = useSelector(getEscalationBasic);
	const escalationSummary = useSelector(getEscalationSummary);
	const campaignsNearingTheEndManager = useSelector(getCampaignsNearingTheEndManager);
	const campaignsNearingTheEndContactRelease = useSelector(getCampaignsNearingTheEndContactRelease);
	const leadsToProcess = useSelector(getLeadsToProcess);

	const hasEscalationBasic = escalationBasic?.length > 0;
	const hasEscalationSummary = escalationSummary?.length > 0;
	const hasCampaignsNearingTheEndManager = campaignsNearingTheEndManager?.length > 0;
	const hasCampaignsNearingTheEndContactRelease = campaignsNearingTheEndContactRelease?.length > 0;
	const hasLeadsToProcess = leadsToProcess?.length > 0;

	const showTodaysUrgencies = any(equals(true))([
		hasEscalationBasic,
		hasEscalationSummary,
		hasCampaignsNearingTheEndManager,
		hasCampaignsNearingTheEndContactRelease,
		hasLeadsToProcess,
	]);

	return (
		showTodaysUrgencies && (
			<Paper sx={{ px: 3, py: 2, borderRadius: 1 }}>
				<Stack
					sx={{
						pt: 2,
					}}
				>
					<SectionHeader
						sx={{ fontWeight: 'bold' }}
						variant="body1"
						text={getMessage('dashboard:todaysUrgencies.title')}
					/>
					<EscalationBasic />
					<EscalationSummary />
					<CampaignsNearingTheEndManager />
					<CampaignsNearingTheEndContactRelease />
					<LeadsToProcess />
				</Stack>
			</Paper>
		)
	);
};

export default TodaysUrgencies;
